import { render, staticRenderFns } from "./BaseInformation.vue?vue&type=template&id=2e128f68"
import script from "./BaseInformation.vue?vue&type=script&lang=js"
export * from "./BaseInformation.vue?vue&type=script&lang=js"
import style0 from "./BaseInformation.vue?vue&type=style&index=0&id=2e128f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports